import { Directive, ElementRef, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Directive({ standalone: true, selector: '[appManageValidatorDisplay]' })
export class ManageValidatorDisplayDirective {
  @Input() private control: AbstractControl;

  constructor(public elementRef: ElementRef) {}
}
